/**
 * "HIGH_END_ELECTRIC_CAR" → "High end electric car". Los proveedores publican
 * sus códigos en mayúsculas y con guiones bajos; puestos tal cual, una lista de
 * chips o de tarifas grita.
 */
export function prettifyCode(value: string): string {
  const clean = value.replace(/_/g, ' ').trim().toLowerCase();
  return clean ? clean.charAt(0).toUpperCase() + clean.slice(1) : '';
}

/** "1h 30m" a partir de una cantidad de minutos publicada por el proveedor. */
export function formatMinutes(minutes?: number): string | undefined {
  if (typeof minutes !== 'number' || minutes <= 0) return undefined;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return hours > 0 ? `${hours}h ${rest}m` : `${rest}m`;
}

/**
 * "2026-09-29T11:00:00" → "29/09/2026 11:00". Hora LOCAL del punto, sin offset:
 * se formatea como texto (igual criterio que trenes y ferrys).
 */
export function formatProviderDateTime(value: string): string {
  const [date, time] = value.split('T');
  const [year, month, day] = (date ?? '').split('-');
  return day ? `${day}/${month}/${year} ${(time ?? '').slice(0, 5)}`.trim() : value;
}

/**
 * El vencimiento de una reserva escrito entero.
 *
 * `expiresAt` es un INSTANTE absoluto (el contrato lo publica en UTC), no una
 * hora local del proveedor como los horarios del itinerario: se convierte a la
 * zona del asesor. Vive acá, en una sola expresión, para que el reloj de la
 * barra y la pregunta al cerrar no puedan decir horas distintas del mismo
 * hold.
 */
export function formatHoldExpiry(expiresAt: string): string {
  return new Date(expiresAt).toLocaleString();
}
